/**
 * True only when REACT_APP_API_URL points at production api.enabill.com.
 * Dev/stage (e.g. api.enabill.dev) keep Sentry / Clarity off.
 */
export function isProductionTrackingEnv() {
  const api = String(process.env.REACT_APP_API_URL || "")
    .trim()
    .toLowerCase();
  return api.includes("api.enabill.com");
}
